import * as React from 'react';
import get from 'lodash/get';

import ProgressBar from 'components/progress/progress-bar/ProgressBar';

import type { Campaign, CampaignOverview } from 'types';

type Props = {
  title: string,
  campaign: Campaign,
  overview: CampaignOverview
};

const CampaignOverviewProgress = ({
  title,
  campaign,
  overview
}: Props) => {
  const plannedBudget = get(campaign, 'budget', 0);
  const usedBudget = get(overview, 'usedBudget', 0);

  return (
    <ProgressBar
      start={{
        value: usedBudget,
        label: {
          text: title,
          isBold: true
        }
      }}
      end={{
        value: plannedBudget,
        label: {
          text: ''
        }
      }}
    />
  );
};

export default CampaignOverviewProgress;
